var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    rx: 22.5,
    fill: "#DB000C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1133 32.2441C15.5039 32.2441 15.7773 32.0488 16.2363 31.6191L19.0781 28.9727C18.5312 28.5332 18.082 27.8398 18.082 26.248V19.7734C18.082 16.7852 19.8984 14.998 22.8965 14.998H29.7324L29.7227 14.6367C29.5762 12.625 28.2578 11.3262 26.0215 11.3262H12.623C10.3867 11.3262 8.91211 12.6641 8.91211 14.998V24.5879C8.91211 26.9023 10.3867 28.3965 12.623 28.3965H14.2441V31.248C14.2441 31.8438 14.5664 32.2441 15.1133 32.2441ZM30.8945 33.5918C31.4512 33.5918 31.7637 33.2012 31.7637 32.5957V29.7539H32.7988C35.0352 29.7539 36.5098 28.2598 36.5098 25.9355V19.998C36.5098 17.6738 35.0352 16.3359 32.7988 16.3359H23.1211C20.7871 16.3359 19.4199 17.6738 19.4199 20.0078V25.9355C19.4199 28.2598 20.7871 29.7539 23.1211 29.7539H26.2461L29.7715 32.9766C30.2305 33.3965 30.5039 33.5918 30.8945 33.5918Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarIcon);
export default __webpack_public_path__ + "static/media/avatar-icon.d1a7cffbc57cb103a797c4a14b10c20b.svg";
export { ForwardRef as ReactComponent };